import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 0;
`;

export const Partner = styled.div`
    width: 100%;
    height: 100%;
    /* min-height: 280px; */
    border: 0;
    border-radius: 4px;
    position: relative;
    background-color: ${({ theme }) => theme.color.white};
`

export const PartnerCover = styled.div`

`

export const WrapCover = styled.div`
    height: 164px;
    overflow: hidden;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
`

export const Cover = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 0px none;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`

export const PartnerDetails = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    position: relative;
    z-index: 1;
    /* margin-top: -40px; */
    padding: 0.625rem;
`;

export const WrapperLogo = styled.div`
    width: 80px;
    min-width: 80px;
    height: 65px;
    overflow: hidden;
    padding: 5px;
    border: 1px solid ${({ theme }) => theme.color.extraLight};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: 0.375rem;
    margin-top: -34px;
`;

export const Logo = styled.img`
    width: 100%;
    height: auto;
    object-fit: cover;
    border: 0px none;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
`

export const Title = styled.div`
    font-size: 1rem;
    color: ${({ theme }) => theme.color.grayBold};
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    line-height: 1;
    margin-bottom: 8px;
    margin-left: 10px;
    width: 100%;
        /* top: 30px; */
    /* position: relative; */
`;

export const Content = styled.div`
    /* padding: 0.625rem; */
`

export const PartnerProducts = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 15px;
    margin-bottom: 5px;
`

export const PartnerProduct = styled.div`
    display: block;
    margin-left: 10px;

    &:first-child {
        margin-left: 0;
    }


    a {
        display: block;
        height: 54px;
        width: 54px;
        border-radius: 0.25rem;
        background-color: ${({ theme }) => theme.color.gray};
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border: 0px none;
            max-width: 100%;
            display: inline-block;
            vertical-align: middle;
        }
    }
`

export const ProductImage = styled.img``

export const Button = styled.button`
    width: 96px;
    min-width: 96px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.light};
    overflow: hidden;
    border-radius: 0.375rem;
    display: block;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.color.grayBold};
    padding: 0.25rem 0.9375rem;
    margin-left: 0.625rem;
    line-height: 1;
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw400};

    svg {
        height: 0.8125rem;
        width: auto;
        position: relative;
        top: 1px;
        margin-left: 0.3125rem;

        path {
            fill: ${({ theme }) => theme.color.gray};
        }
    }

`
